module.exports = __webpack_public_path__ + "img/img_kongshujv.9df0add2.png";